export default __webpack_public_path__ + "static/azure-a168500c6c7dfbd88452fdcd43e596d0.png";